import React from 'react'

import DateFilter from '../../../../components/filter/DateFilter'
import GroupsFilterV2 from '../../../../containers/groups/filters/GroupsFilterV2'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  return (
    <ScreenViewFilterBar screen="segments" open={open}>
      <GroupsFilterV2 />
      <DateFilter label="Criação" field="insertedAt" />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
